import ExpandableList from "../common/ExpandableList";
import TowTask, {TowTaskForm} from "./TowTask";
import {REST_TOW_TASK_URL} from "../common/constants";


export const TowTaskList = ExpandableList(TowTask, TowTaskForm, REST_TOW_TASK_URL, "towtask", "Seznam úloh", "Nová úloha", "Přidat úlohu",  ((a,b) => (a.name && a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))));

